import { render } from "./NcrmHomeBoardMetrics.vue?vue&type=template&id=09ea3ecf&scoped=true"
import script from "./NcrmHomeBoardMetrics.vue?vue&type=script&lang=js"
export * from "./NcrmHomeBoardMetrics.vue?vue&type=script&lang=js"

import "./NcrmHomeBoardMetrics.vue?vue&type=style&index=0&id=09ea3ecf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ea3ecf"]])

export default __exports__